import axios from 'axios'
axios.defaults.baseURL = '/'

export default {
  // ...axios,
  // 属模糊查询
  // 验证登录
  checkLogin () {
    return axios.post('/web/checkLogin')
  },
  // 查看下载是否需要登录
  async getSetCheckLogin () {
    var result = ''
    await axios.get('/base/getSettingByModule?module=algae').then(async res => {
      if (res.data.data[0].settingValue === 'true') {
        await axios.post('/web/checkLogin').then(res1 => {
          if (res1.data.code === 200) {
            result = res1
          } else {
            result = res1.data.msg
          }
        })
      } else {
        result = ''
      }
    }).catch(err => {
      result = err
    })
    return result
  },
  getGenusList (
    user,
    startCreateTime,
    endCreateTime,
    startUpdateTime,
    endUpdateTime
  ) {
    return axios.get(
      `/genusList?name=${user}&startCreateTime=${startCreateTime}&endCreateTime=${endCreateTime}&startUpdateTime=${startUpdateTime}&endUpdateTime=${endUpdateTime}&currentPage=1&pageSize=10`,
      { baseURL: '/algae' }
    )
  },
  genusDelete (id) {
    return axios.post(`/algae/genusDelete?id=${id}`)
  },
  postGenusIncrease (genusName) {
    return axios.post(`/algae/genusInsert?genusName=${genusName}`)
  },
  postGenusUpdate (mes) {
    return axios.post('/genusUpdate', mes, { baseURL: '/algae' })
  },
  // 获取毒株信息
  getAnnotationFuzzyQuery (
    user,
    code,
    startCreateTime,
    endCreateTime,
    startUpdateTime,
    endUpdateTime,
    page
  ) {
    return axios.get(
      `/annotationFuzzyQuery?name=${user}&code=${code}&startCreateTime=${startCreateTime}&endCreateTime=${endCreateTime}&startUpdateTime=${startUpdateTime}&endUpdateTime=${endUpdateTime}&currentPage=${page}&pageSize=9`,
      { baseURL: '/algae' }
    )
  },
  // 添加毒株
  annotationInsert (mes) {
    return axios.post('/algae/annotationInsert', mes)
  },
  // 毒株文件查重
  checkFileByAnnotation (id, nameList) {
    return axios.post(`/algae/checkFileByAnnotation?id=${id}`, nameList)
  },
  // 更新毒株信息
  updataAnnotationFile (annotationId, details) {
    return axios.post(
      `/algae/updataAnnotationFile?annotationId=${annotationId}`,
      details
    )
  },
  // 修改毒株
  modifyByStrain (mes) {
    return axios.post('/algae/modifyByStrain', mes)
  },
  // 毒株 导入序列检验
  importSequence (mes) {
    return axios.post('/algae/importSequence', mes)
  },
  // 删除毒株文件
  deleteFileByAnnotationName (name, id) {
    return axios.post(`/algae/deleteFileByAnnotationName?name=${name}&id=${id}`)
  },
  // 批量删除毒株文件
  deleteSpeciesFileById (list) {
    return axios.post('/algae/deleteSpeciesFileById', list)
  },
  // 批量删除毒株
  deleteByStrainList (list) {
    return axios.post(`/algae/deleteByStrainList`, list)
  },
  // 删除毒株
  deleteByStrain (id) {
    return axios.post(`/algae/deleteByStrain?id=${id}`)
  },
  // 物种模糊查询
  getFuzzyQueryByspecies (
    user,
    code,
    genusName,
    startCreateTime,
    endCreateTime,
    startUpdateTime,
    endUpdateTime,
    page
  ) {
    return axios.get(
      `/fuzzyQueryByspecies?name=${user}&code=${code}&genusName=${genusName}&startCreateTime=${startCreateTime}&endCreateTime=${endCreateTime}&startUpdateTime=${startUpdateTime}&endUpdateTime=${endUpdateTime}&currentPage=${page}&pageSize=9`,
      { baseURL: '/algae' }
    )
  },
  // 获取选择属
  genusChoice () {
    return axios.get('/algae/genusChoice')
  },
  // 根据id获取物种详情
  speciesListById (id) {
    return axios.get(`/algae/speciesListById?id=${id}`)
  },
  // 修改物种信息
  speciesUpdate (data) {
    return axios.post('/algae/speciesUpdate', data)
  },
  // 添加物种信息
  speciesInsert (data) {
    return axios.post('/algae/speciesInsert', data)
  },
  // 添加图片
  speciesUpdataImage (id, file) {
    return axios({
      method: 'post',
      url: `/algae/speciesUpdataImage?id=${id}`,
      data: file,
      headers: { 'Content-Type': 'multipart/form-data' }
    })
  },
  // 添加文献
  literatureInsert (data) {
    return axios.post('/algae/literatureInsert', data)
  },
  // 修改文献
  modifyByLiterature (data) {
    return axios.post('/algae/modifyByLiterature', data)
  },
  // 删除文献
  deleteByLiterature (id) {
    return axios.post(`/algae/deleteByLiterature?id=${id}`)
  },
  // 文件查重
  checkByspeciesFile (id, data) {
    return axios.post(`/algae/checkByspeciesFile?id=${id}`, data)
  },
  // 文件删除
  deleteFileBySpecies (id) {
    return axios.post(`/algae/deleteFileBySpecies?id=${id}`)
  },
  // 文件上传
  classifyAndUploading (id, files) {
    return axios({
      method: 'post',
      url: `/storage/classifyAndUploading?geneDatabaseId=${id}`,
      data: files,
      headers: { 'Content-Type': 'multipart/form-data' }
    })
  },
  // 更新物种信息
  updataSpeciesFile (id, data) {
    return axios.post(`/algae/updataSpeciesFile?speciesId=${id}`, data)
  },
  // 删除物种
  deleteBySpecies (id) {
    return axios.post(`/algae/deleteBySpecies?id=${id}`)
  },
  // 获取模板位置
  downloadTemplate () {
    return axios.post('/algae/downloadTemplate')
  },
  // 表头检测
  getExcelFileContent (file, val) {
    let title = ''
    if (val === 'species') {
      title =
        'FWAlgaeDB ID Number,Species,Genus,Family,Order,Class,Phylum,Kingdom,Synonymous name,NCBI Taxonomy ID,Geographic Location,Living Environment,Open,Reference1,Reference2,Reference3,Reference4,Reference5'
    } else if (val === 'strain') {
      title = 'serialCode,strainName'
    } else if (val === 'genus') {
      title = 'genusName'
    }
    return axios({
      method: 'post',
      url: `/base/getExcelFileContent?title=${title}`,
      data: file,
      headers: { 'Content-Type': 'multipart/form-data' }
    })
  },
  // 导入数据(excel)
  importTemplateByAlage (list) {
    return axios.post('/algae/importTemplateByAlage', list)
  },
  // 导入图片
  speciesImportImage (file) {
    return axios({
      method: 'post',
      url: '/algae/speciesImportImage',
      data: file,
      headers: { 'Content-Type': 'multipart/form-data' }
    })
  },
  // 导出
  speciesDataExport (list) {
    return axios.post('/algae/speciesDataExport', list)
  },
  // 批量删除物种
  deleteBySpeciesList (list) {
    return axios.post('/algae/deleteBySpeciesList', list)
  },
  // 批量删除属
  genusDeleteList (list) {
    return axios.post('/algae/genusDeleteList', list)
  },
  // 毒株批量删除文件
  deleteAnnotationFileById (list) {
    return axios.post('/algae/deleteAnnotationFileById', list)
  },
  // 导入物种文件检测
  importSpeciesFile (list) {
    return axios.post('/algae/importSpeciesFile', list)
  },
  // 下载单个文件
  getFileOutputStreamById (fileId) {
    return axios.get(`/storage/getFileOutputStreamById?fileId=${fileId}`)
  },
  // 查询文件id是否存在
  queryFileInfoById (fileId) {
    return axios.get(`/storage/queryFileInfoById?fileId=${fileId}`)
  },
  // 首页获取模糊搜索的数据
  fuzzyList (key) {
    return axios.get(`/algae/fuzzyList?key=${key}`)
  },
  // 首页获取模糊搜索的数据
  uploadfile (file) {
    return axios({
      method: 'post',
      url: '/base/uploadfile',
      data: file,
      headers: { 'Content-Type': 'multipart/form-data' }
    })
  },
  // 导入毒株excel
  importTemplateByStrain (data) {
    return axios.post(`/algae/importTemplateByStrain`, data)
  },
  // 导入属excel
  importTemplateByGenus (data) {
    return axios.post(`/algae/importTemplateByGenus`, data)
  },
  // blast获取结果
  getCmdGroupTasks (taskGroupId) {
    return axios.get(`/base/getCmdGroupTasks?gid=${taskGroupId}&module=algae`)
  },
  // 生成blast结果序列
  downloadSeqBaseArchiveData (libraryId, downloadType, databaseType, nameList) {
    return axios.post(`/base/downloadSeqBaseArchiveData?libraryid=${libraryId}&downloadtype=${downloadType}&databaseType=${databaseType}`, nameList)
  },
  // 获取下载是否需要登录验证
  getSettingByModule () {
    return axios.get('/base/getSettingByModule?module=algae')
  },
  // 设置下载是否需要登录验证
  updateSetting (obj) {
    return axios.post('/base/updateSetting', obj)
  }
}



// WEBPACK FOOTER //
// ./src/utils/api.js